import { I4BCellType } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType } from '../models';
import { I4BButtonColumn } from './i4b-button.column';

export class NtePeripheralsButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.PERIPHERALS,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          bulkActions: [
            {
              order: 1,
              key: 'addPeripherals',
              label: 'DEVICES.SYNOPTIC.PERIPHERALS.ADD_PERIPHERALS',
              displaySingleAction: true,
              icon: 'add',
              enableConditions: [],
              visibleConditions: [
                [
                  {
                    key: 'canConfigure',
                    value: true
                  }
                ],
                [
                  {
                    key: 'canAddPeripherals',
                    value: true
                  }
                ],
                [
                  {
                    key: 'canUpdateDevice',
                    value: true
                  }
                ]
              ]
            }
          ],
          singleActions: [
            {
              order: 1,
              key: 'addPeripheral',
              label: 'DEVICES.SYNOPTIC.PERIPHERALS.ADD_PERIPHERAL',
              displaySingleAction: true,
              icon: 'add',
              enableConditions: [],
              visibleConditions: [
                [
                  {
                    key: 'canConfigure',
                    value: true
                  }
                ],
                [
                  {
                    key: 'canAddPeripherals',
                    value: true
                  }
                ],
                [
                  {
                    key: 'canUpdateDevice',
                    value: true
                  }
                ]
              ]
            }
          ],
          disableConditions: [],
          enableConditions: [],
          visibleConditions: [
            [
              {
                key: 'canConfigure',
                value: true
              }
            ],
            [
              {
                key: 'canAddPeripherals',
                value: true
              }
            ],
            [
              {
                key: 'canUpdateDevice',
                value: true
              }
            ]
          ]
        }
      },
      { order: 1000 }
    );
  }
}
